var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"questionnaire"},[_c('Header',{attrs:{"type":"questionnaire"}}),_c('div',{staticClass:"block"},[_c('router-view')],1),_c('Progress')],1)}
var staticRenderFns = []

export { render, staticRenderFns }